import { FaCheck } from "react-icons/fa";
import { IoClose, IoSparkles } from "react-icons/io5";
import styled from "styled-components";

const borderStyleChecked = () => {
    return `3px solid var(--color-petrol);`
}

const borderStyle = (isPackage: boolean) => {
    if(isPackage) {
        return `1px solid #eeeeee;`
    } else {
        return `1px solid #DEDEDE;`
    }
}

export const Background = styled.div`
  width: 100%
`;

export const Container = styled.div`
    padding: 24px 16px;
    @media (min-width: 768px) {
        width: 60%;
        margin-left: auto;
        margin-right: auto;
    }
    @media (min-width: 1024px) {
        width: 40%;
        margin-left: auto;
        margin-right: auto;
    }
`;

export const Headline = styled.h2`
    font-size: 28px;
    margin-bottom: 14px; 
`;

export const Subtitle = styled.p`
    font-size: 18px;
    margin-bottom: 24px;
`;

export const ProductName = styled.span<{productTargetVariant?: string}>`
    width: 100%;
    font-weight: 600;
    padding-left: ${({productTargetVariant}) => productTargetVariant === "fagforeningloensikring" ? "40px;" : "40px;"}
    cursor: pointer;
    display: block;
    
`;

// ${({productTargetVariant}) => productTargetVariant === "fagforeningloensikring" && `
//         display: block;`
//     }

export const ProductCardContainer = styled.div`
`;

export const ProductCard = styled.div<{ isPackage: boolean, checked: boolean | undefined, isSelfemployeedPackage: boolean}>`
    width: 100%; 
    font-size: 18px;
    border: ${({checked, isPackage }) => (checked && !isPackage ? borderStyleChecked : borderStyle(isPackage) )}
    border-radius: ${({ isPackage }) => (isPackage ? "0px" : "12px")};
    background-color: #ffffff;
    position: relative;
    margin-bottom: ${({ isPackage }) => (isPackage ? "0px" : "8px")};
    ${({ isSelfemployeedPackage }) => isSelfemployeedPackage && `
        border-bottom: 3px solid #17447A !important;
        border-left: 3px solid #17447A !important;
        border-right: 3px solid #17447A !important;
        border-bottom-left-radius: 12px !important;
        border-bottom-right-radius: 12px !important;
        border-top-left-radius: 0px !important;
        border-top-right-radius: 0px !important;
        border-top: 0px !important;
        &:first-child {
            border-top: 3px solid #17447A !important;
            border-left: 3px solid #17447A !important;
            border-right: 3px solid #17447A !important;
            border-top-left-radius: 12px !important;
            border-top-right-radius: 12px !important;
             border-bottom-left-radius: 0px !important;
             border-bottom-right-radius: 0px !important;
            border-bottom: 0px !important;
            margin-bottom: 0px !important;
        }
    `}
    cursor: pointer;
    &:first-child {
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
    }
`;

export const SelfEmployedPackage = styled.div`
    border: 3px solid #17447A;
    border-radius: 12px;
`;

export const TopContainerCard = styled.div`
    padding: 16px 12px;
`;

export const ProductInfo = styled.div`
    background-color: #292928;
    color: #ffffff;
    text-align: center; 
    padding: 12px 8px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    font-size: 14px;
    cursor: pointer;
    p {
        margin-bottom: 0px;
    }
`;

export const PackageInfo = styled.div`
    background-color: rgb(41, 41, 40);
    color: rgb(255, 255, 255);
    text-align: center;
    padding: 12px 8px;
    font-size: 14px;
    p {
        margin-bottom: 0px;
    }
`;

export const InputContainer = styled.div<{productTargetVariant?: string}>`
    display: ${({productTargetVariant}) => productTargetVariant === "fagforeningloensikring" ? "flex" : "flex"}; 
    justify-content: space-between;
    align-items: center;
`;

export const Price = styled.p<{ strikeThrough?: boolean | undefined, productTargetVariant?: string}>`
    font-weight: 600;
    margin-bottom: 0px;
    white-space: nowrap;
    span {
        font-weight: 500;
        color: #7B7B7A;
    }
    text-decoration: ${({ strikeThrough }) => (strikeThrough ? "line-through" : "none")};
      ${({productTargetVariant}) => productTargetVariant === "fagforeningloensikring" && `
        margin-top: 8px;`
    }
`;

export const Label = styled.label`
    width: 0;
    display: none;
`;

export const Input = styled.input`
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
`;

export const CustomInput = styled.span <{ checked: boolean | undefined }>`
    position: absolute;
    height: 30px;
    width: 30px;
    background-color: ${({ checked }) => (checked ? "#292928" : "#eee")};
    border: 1px solid #cccccc;
    cursor: pointer;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Checked = styled(FaCheck)`
    color: #ffffff;
`;

export const UnorderedList = styled.ul`
    padding-top: 16px;
    margin-left: 3px; 
    margin-bottom: 0px;
    list-style: disc;
`;

export const InfoLi = styled.li`
    color: #7B7B7A;
    margin-bottom: 4px;
    font-size: 16px;
    &::marker {
        color: var(--color-orange)
    }
`;

export const InfoBtn = styled.button`
    color: var(--color-orange); 
    cursor: pointer;
    margin-top: 8px;
    text-decoration: underline;
`;

export const TotalTop = styled.div<{isPackage: boolean}>`
    background-color: var(--color-petrol);
    border: 1px solid var(--color-petrol);
    border-top-left-radius: ${({ isPackage }) => (isPackage ? "0px" : "12px")};
    border-top-right-radius: ${({ isPackage }) => (isPackage ? "0px" : "12px")};
    color: #ffffff;
    padding: 16px 10px;
    font-size: 18px;
`;

export const TotalRow = styled.div`
    display: flex; 
    justify-content: space-between;
    align-items: center;
`;

export const TotalText = styled.p`
    margin-bottom: 0px;
`;

export const TotalPrice = styled.p`
    font-weight: 600; 
    margin-bottom: 0px;
    span {
        font-weight: 500;
    }
`;

export const TotalBottom = styled.div`
    background-color: #006571;
    border: 1px solid #006571;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
    color: #ffffff;
    padding: 10px;
`;
    
export const TotalCall = styled.div`
    margin-bottom: 0px;
    font-size: 16px;
    cursor: pointer;
    text-align: center;
    a {
        text-decoration: underline;
    }
`;
export const ButtonContainer = styled.div`
    width: 100%;
    margin-top: 10px;
`;

export const Button = styled.a<{ active?: boolean | undefined }>`
    background-color: ${({ active }) => (!active ? "#cccccc" : "var(--color-orange)")} ;
    color:  var(--color-white);
    font-size: 18px;
    font-weight: var(--font-weight-bold);
    border-radius: 35px;
    padding: 16px 44px;
    text-decoration: none;
    display: block;
    text-align: center;
    disabled: ${({ active }) => (!active ? "true" : "false")};
    pointer-events: ${({ active }) => (!active ? "none" : "auto")};
`;

export const PackageContainer = styled.div<{isPackage: boolean}>`
    border: ${({ isPackage }) => (isPackage ? "3px solid var(--color-petrol)" : "0px")};
    border-top-right-radius: ${({ isPackage }) => (isPackage ? "12px" : "0px")};
    border-top-left-radius: ${({ isPackage }) => (isPackage ? "12px" : "0px")};
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
`;

export const ContactMeContainer = styled.div`
    position: fixed;
    z-index: 5000;
    left: 0;
    top: 0;
    width: 100%;
    min-height: -webkit-fill-available;
    overflow: auto;
    background-color: #006571;
    max-height: 100vh !important;
    overflow-y: scroll;
    p {
    margin-bottom: 0px;
    }
`;

export const ContactMeContent = styled.div`
    width: 90%;
    text-align: center;
    color: #ffffff;
    margin-left: auto; 
    margin-right: auto;
    @media (min-width: 1024px) { 
        width: 40%;
    }
`;

export const ContactMeHeadline = styled.h1`
    padding-top: 40px;
`;

export const ContactMeSubtitle = styled.p`
    font-size: 16px;
    margin-top: 18px;
`;

export const Close = styled.div`
    display: flex;
    justify-content: end;
    padding: 16px;
`;

export const CloseButton = styled.button`
    display: flex;
    float: right;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    cursor: pointer;
`;

export const CloseIcon = styled(IoClose)`
    color: #ffffff;
    width: 35px;
    height: 35px;
    cursor: pointer;
`;

export const ModalInputContainer = styled.div`
    margin-top: 32px;
    margin-bottom: 24px;
`;

export const ModalInput = styled.input`
    padding: 20px 16px;
    border-radius: 8px;
    display: block;
    margin-top: 8px;
    width: 100%;
    border: 1px solid var(--color-grey-100);
    background-color: #fff;
    margin-top: 10px;
    font-size: 16px;
    color: var(--color-coal);
    &:focus-visible {
        outline: 2px solid var(--color-coal);
    }
`;

export const ErrorMessage = styled.p`
    color: var(--color-alert-color);
    text-align: left;
`;